export const plans = [{
    'ID': 1,
    'Status': '2020',
    'Client': 'Lebanon',
    'Plan Owner': 'Agency1',
    'Media': 'Media1',
    'SubMedia': 'Sub Media 1 ',
    'M. Level1': 'Sub Media 1 ',
    'M. Level5': 'Sub Media 1 ',
    'Campaign': 'Sub Media 1 ',
    'Vehicle': 'Sub Media 1 ',
    'Start Date': 'Sub Media 1 ',
    'Start Date': 'Sub Media 1 ',
    'End Date': 'Sub Media 1 ',
    'Currency': 'Sub Media 1 ',
    'Net Cost': 'Sub Media 1 ',
    'Fees': 10,
    'Net Net Fees': 20    
  }]